import React from 'react';
import { IRifa } from '../../types/rifa';
import './PremioRifa.scss';
import { calculateScaleRotatedImage } from '../../utils/FunctionUtils';

interface Props {
	rifa: IRifa,
	numRotacoes?: number
}

interface State {
	rate?: number,
	originalWidth?: number,
	originalHeight?: number
}

const ALTURA_MAXIMA_IMAGEM_VH = 80;
const LARGURA_MAXIMA_IMAGEM_VW = 90;

class PremioRifa extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			rate: undefined
		}
	}

	render(): JSX.Element {
	const {
		rifa,
		numRotacoes
	} = this.props;
	const { 
		rate
	} = this.state;
	
	const onLoadImage = (event: any) => {
		const originalWidth = event.target.naturalWidth;
		const originalHeight = event.target.naturalHeight;

		// As dimensões da foto do prêmio não são fixas (elas são definidas pela foto original)
		const alturaMaxima = Math.min(Math.round(window.innerHeight / 100) * ALTURA_MAXIMA_IMAGEM_VH, originalHeight);
		const larguraMaxima = Math.min(Math.round(window.innerWidth / 100) * LARGURA_MAXIMA_IMAGEM_VW, originalWidth);

		// Calcula o fator de redimensionamento
		this.setState({ rate: calculateScaleRotatedImage(originalWidth, originalHeight, larguraMaxima, alturaMaxima) });
	}

	// props.numRotacoes%2 === 1 é true se a imagem foi girada -90 ou 90 graus
	const scaleStr = (numRotacoes && (numRotacoes % 2 === 1) && rate) ? `scale(${rate})` : '';

	let imgSrc;
	if (rifa.fotoPremio)
		imgSrc = `data:image/png;base64,${rifa.fotoPremio}`;
	else if (rifa.pathFotoPremio)
		imgSrc = rifa.pathFotoPremio;

   return (
		<section className="panel-bg-primary p-3 p-md-5 mt-2">
			<div className="padding-x">
				<div className="text-center">
						<span className="title-sm-common title-secondary mb-3 d-block">
							O prêmio
						</span>

						<span style={{ lineHeight: '1.5', fontSize: '1.2rem' }}>
							{rifa.descricaoPremio}
						</span>
				</div>
			</div>

			<div className="mt-4 foto-premio-container">
				{ imgSrc ?
					<img src={imgSrc}
						className="foto-premio"
						title="Foto do Prêmio"
						alt="Rifa Tech - Prêmio"
						style={{
							transform: numRotacoes ? `rotate(${numRotacoes * 90}deg) ${scaleStr}` : '',
							WebkitTransform: numRotacoes ? `rotate(${numRotacoes * 90}deg) ${scaleStr}` : '',
							msTransform: numRotacoes ? `rotate(${numRotacoes * 90}deg) ${scaleStr}` : '',
							OTransform: numRotacoes ? `rotate(${numRotacoes * 90}deg) ${scaleStr}` : ''
						}}
						onLoad={onLoadImage} />
					: null
				}
			</div>
		</section>
	);
	}
}

export default PremioRifa;